var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { Component } from 'react';
import './DatePicker.css';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { Input } from 'elements';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        _this.id = "datepicker-".concat(_this.props.name);
        _this.handleHourChange = function (event) {
            if (Number(event.target.value) < 24 && Number(event.target.value) >= 0) {
                _this.setState({ hours: event.target.value }, function () { return _this.props.onChange('hora', { hours: _this.state.hours, minutes: _this.state.minutes }); });
            }
        };
        _this.handleMinutesChange = function (event) {
            if (Number(event.target.value) < 60 && Number(event.target.value) >= 0) {
                _this.setState({ minutes: event.target.value }, function () { return _this.props.onChange('hora', { hours: _this.state.hours, minutes: _this.state.minutes }); });
            }
        };
        _this.handleKeyDown = function (event) {
            console.log('event.keyCode', event.keyCode);
            console.log('event', event);
            if (event.keyCode === 13 || event.keyCode === 9) {
                _this.setState(function (prev) {
                    return {
                        hours: _this.ceros(Number(prev.hours)),
                        minutes: _this.ceros(Number(prev.minutes)),
                    };
                });
            }
        };
        _this.ceros = function (value) {
            if (value > 9) {
                return String(value);
            }
            return '0'.concat(String(value));
        };
        var date = new Date();
        _this.state = {
            hours: _this.ceros(_this.props.hora.hours),
            minutes: _this.ceros(_this.props.hora.minutes)
        };
        return _this;
        // console.log(this.id)
    }
    default_1.prototype.render = function () {
        var _a = this.props, name = _a.name, onChange = _a.onChange, onKeyPress = _a.onKeyPress, props = __rest(_a, ["name", "onChange", "onKeyPress"]);
        var _b = this.state, hours = _b.hours, minutes = _b.minutes;
        return (React.createElement("div", __assign({}, props),
            React.createElement(TimePicker, null,
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'hora', value: hours, min: 0, max: 23, onKeyDown: this.handleKeyDown, 
                        /*onKeyPress={this.handleClick}*/
                        onChange: this.handleHourChange })),
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'minutos', value: String(minutes), min: 0, max: 59, onKeyDown: this.handleKeyDown, onChange: this.handleMinutesChange })))));
    };
    return default_1;
}(Component));
export default default_1;
var TimePicker = cxs('div')((_a = {
        padding: Theme.size.space[1],
        textAlign: 'center',
        borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _a[mediaQueries.desktop] = {
        border: 0,
        outline: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _a));
var TimeInput = cxs('div')({
    width: '4em',
    margin: "0 ".concat(Theme.size.space[1]),
    display: 'inline-block'
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/TimePicker.tsx
// module id = 957
// module chunks = 0